<template>
  <div>
    <div class="left-box">
      <div class="menu-header">
        <img :src="user.mthumb"
             class="header-avatar">
        <div class="header-name">{{user.mnickname}}</div>
      </div>
      <div class="menus">
        <div class="flex flex-direction" v-for="item in nav" :key="item.active">
          <div class="mune-item" :class="{active : active === item.active}"
               @click="item.list.length > 0 ? item.show = !item.show : go(item.url)">
            <i :class="item.icon"></i>
            <div class="title">{{item.name}}</div>
            <i class="iconfont icon-xiajiantou"
               v-if="item.list.length > 0" :class="{zhuan : item.show}"></i>
          </div>
          <div class="item-list" v-if="item.show">
            <p v-for="itm in item.list"
               :key="itm.act"
               :class="{act : active === item.active && act === itm.act}"
               @click="go(itm.url)"><span></span>{{itm.title}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "leftPage",
  data() {
    return {
      nav:[
        {
          name:'首页',
          active:0,
          url:'/home/index',
          icon:'iconfont icon-menu-s',
          show:false,
          list:[]
        },
        {
          name:'专家管理',
          active: 1,
          url:'',
          icon:'iconfont icon-zhaozhuanjia',
          show:false,
          list:[
              {
                  title:'专家分类',
                  url:'/home/type',
                  act:5
              },
            {
              title:'专家领域',
              url:'/home/field',
              act:0
            },
            {
              title:'专家审核',
              url:'/home/examine',
              act:1
            },
            {
              title:'专家信息',
              url:'/home/detail',
              act:2
            },
            {
              title:'专家邀请',
              url:'/home/invitation',
              act:3
            },
            {
              title:'预约信息',
              url:'/home/reservation',
              act:4
            }
          ]
        },
        {
          name:'机构管理',
          active: 2,
          url:'',
          icon:'iconfont icon-bangong-jigou',
          show:false,
          list:[
            {
              title:'机构信息',
              url:'/home/information',
              act: 0
            },
            {
              title:'密码修改',
              url:'/home/pass',
              act: 1
            }
          ]
        },
        {
          name:'展示页面',
          active: 3,
          url:'/home/exhibition',
          icon:'iconfont icon-diannao',
          show:false,
          list:[]
        },
        {
          name:'帮助中心',
          active: 4,
          url: 1,
          icon:'iconfont icon-i8',
          show:false,
          list:[]
        },
      ]
    }
  },
  props: {
    active: {
      type: Number,
      default: 0
    },
    act:{
      type: Number,
      default: -1
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  components: {},
  created() {
    this.$nextTick(() => {
      this.nav.map(item => {
        if(item.active == this.active){
          item.show = true
        }
      })
    })
  },
  methods: {
    go(path){
      if(path == 1){
        let routerJump = this.$router.resolve({
          path: '/help',
          query: {

          }
        });
        window.open(routerJump.href, "_parent");
        return
      }
      let nowPath = this.$route.path
      if(path !== nowPath) {
        this.$router.replace(path)
      }
    },
  },
  watch: {

  },
  filters: {}
}
</script>

<style scoped lang="scss">
.left-box {
  display: flex;
  flex-direction: column;
  width: 170px;
  flex-shrink: 0;
  height: 100%;
  .menu-header {
    width: 100%;
    min-height: 157px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #0a2240;
    border-radius: 10px;
    padding: 12px 26px;

    img {
      width: 85px;
      height: 85px;
      border-radius: 85px;
    }

    .header-name {
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      color: #fff;
      margin-top: 12px;
    }
  }
  .menus {
    width: 100%;
    flex: 1;
    background-color: #0a2240;
    box-shadow: 0 6px 16px 1px rgba(10,34,64,.5);
    border-radius: 10px;
    margin-top: 10px;
    .item-list {
      width: 100%;
      //padding: 5px 0;
      p {
        width: 100%;
        padding: 15px 0;
        font-size: 14px;
        color: #ffffff;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        span {
          display: inline-block;
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background-color: #ffffff;
          margin-left: 30px;
          margin-right: 15px;
        }
        &.act {
          color: #ff9600;
          span {
            background-color:  #ff9600;
          }
        }
      }
    }
    .mune-item {
      height: 65px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      background: none;
      position: relative;
      cursor: pointer;
      padding: 0 20px;
      &.active {
        background: #041832;
        border-radius: 10px;
        i:first-child {
          color: #ff9600;
        }
        i:last-child {
          color: #ff9600;
        }
        .title {
          color: #ff9600;
        }
      }
      &.active:before {
        position: absolute;
        right: -8px;
        border-top: 8px solid transparent;
        border-left: 8px solid #041832;
        border-bottom: 8px solid transparent;
        top: 50%;
        transform: translateY(-50%);
        content: "";
      }
      i:first-child {
        font-size: 20px;
        color: #fff;
        margin-right: 6px;
      }
      i:last-child {
        font-size: 14px;
        color: #fff;
        transition: 0.2s;
        transform: rotate(-90deg);
      }
      .zhuan {
        transform: rotate(0deg) !important;
        transition: 0.2s;
      }
      .title {
        font-size: 16px;
        color: #fff;
        font-weight: bold;
        flex: 1;
        width: 0;
        //&:after {
        //  position: absolute;
        //  right: 0;
        //  bottom: 0;
        //  width: 100%;
        //  height: 1px;
        //  background: hsla(0,0%,100%,.2);
        //  transform: translateY(-50%);
        //  content: "";
        //}
        &:before {
          position: absolute;
          right: 0;
          top: 0;
          width: 100%;
          height: 1px;
          background: hsla(0,0%,100%,.2);
          transform: translateY(-50%);
          content: "";
        }
      }
    }
  }
}
</style>


